import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instrucoes-importacao',
  templateUrl: './instrucoes-importacao.component.html',
  styleUrls: ['./instrucoes-importacao.component.css']
})
export class InstrucoesImportacaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
